/* Bigalli · Trade 2027 — download gate, toast, gallery lightbox */
(function () {
  if (window.BigalliTrade) return;
  var KEY = 'bigalli_trade_2027_unlocked';
  var d = document;
  var toastEl, toastT;

  function toast(msg) {
    if (!toastEl) { toastEl = d.createElement('div'); toastEl.className = 'bt-toast'; toastEl.setAttribute('role', 'status'); d.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  function store(v) { try { v ? localStorage.setItem(KEY, '1') : localStorage.removeItem(KEY); } catch (e) {} }
  function stored() { try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; } }

  function unlockAll() {
    d.querySelectorAll('.bt-res__btn[data-href]').forEach(function (a) {
      a.href = a.getAttribute('data-href');
      a.target = '_blank'; a.rel = 'noopener';
      a.classList.add('is-open');
      a.removeAttribute('data-href');
      var l = a.querySelector('.bt-res__label'); if (l && l.dataset.open) l.textContent = l.dataset.open;
      var i = a.querySelector('.bt-res__icon'); if (i) i.textContent = '↓';
    });
    d.querySelectorAll('[data-bt-note]').forEach(function (n) { if (n.dataset.open) n.textContent = n.dataset.open; });
    if (!d.querySelector('[data-bt-posted]')) {
      d.querySelectorAll('[data-bt-form-wrap]').forEach(function (f) { var form = f.closest('form'); (form || f).hidden = true; });
      d.querySelectorAll('[data-bt-done]').forEach(function (c) { c.hidden = false; });
    }
  }

  function initGate() {
    if (d.querySelector('[data-bt-posted]')) { store(true); toast('Resources unlocked'); }
    if (stored()) unlockAll();
  }

  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-bt-download]');
    if (a && a.classList.contains('is-open')) toast(a.getAttribute('data-bt-download') + ' — your download has started');
  });

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function initGallery(root) {
    if (root.__btInit) return; root.__btInit = true;
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-bt-lb]'));
    var lb = root.querySelector('.bt-lb');
    if (!lb || !items.length) return;
    d.body.appendChild(lb);
    var img = lb.querySelector('.bt-lb__img'), brief = lb.querySelector('.bt-lb__brief'),
        cap = lb.querySelector('.bt-lb__caption'), cnt = lb.querySelector('.bt-lb__count'),
        closeBtn = lb.querySelector('.bt-lb__close'), idx = 0;

    function show(n) {
      idx = (n + items.length) % items.length;
      var ds = items[idx].dataset;
      if (ds.full) { img.src = ds.full; img.alt = ds.caption || ''; img.hidden = false; brief.textContent = ''; }
      else { img.hidden = true; img.removeAttribute('src'); brief.textContent = ds.brief || ''; }
      cap.textContent = ds.caption || '';
      cnt.textContent = pad(idx + 1) + ' / ' + pad(items.length) + (ds.material ? ' · ' + ds.material : '');
    }
    function open(n) { show(n); lb.hidden = false; d.documentElement.style.overflow = 'hidden'; closeBtn.focus(); }
    function close() { lb.hidden = true; d.documentElement.style.overflow = ''; items[idx].focus(); }

    items.forEach(function (b, n) { b.addEventListener('click', function () { open(n); }); });
    closeBtn.addEventListener('click', close);
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    lb.querySelectorAll('.bt-lb__nav').forEach(function (b) {
      b.addEventListener('click', function () { show(idx + Number(b.dataset.dir)); });
    });
    d.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(idx + 1);
      else if (e.key === 'ArrowLeft') show(idx - 1);
    });
    var x0 = null;
    lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1));
    });
  }

  function init() {
    initGate();
    d.querySelectorAll('[data-bt-gallery]').forEach(initGallery);
  }

  window.BigalliTrade = { unlock: function () { store(true); unlockAll(); }, reset: function () { store(false); location.reload(); }, toast: toast };

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  d.addEventListener('shopify:section:load', function (e) {
    var g = e.target.querySelector('[data-bt-gallery]'); if (g) initGallery(g);
    if (stored()) unlockAll();
  });
})();
